import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsCompaniesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Companies</div>
          <div className="text">
            Companies are created by associating them to users using Canny's SDK, SSO tokens, or the
            API. The API allows you to delete a specific company.
          </div>
        </div>
        <div></div>
      </APIDocsBlock>
    );
  }
}
